import { bind, Component, h, tag } from "omi";

import globalStyles from "@/globals/styles.css?inline";
import { Store } from "@/store";
import { tailwind } from "@/tailwind";

type Props = {
  to: string;
};

@tag("nw-content-link")
export class NWContentLink extends Component<Props> {
  static css = [tailwind, globalStyles, `:host { display: inline; font-family: inherit !important; cursor: pointer; }`];

  static propTypes = {
    to: String,
  };

  @bind
  private onClick() {
    const scrollToEvent = new CustomEvent("scroll_to_step", { detail: { stepId: this.to } });
    document.dispatchEvent(scrollToEvent);

    if (Store.project.id.value) {
      import("@/services/analyticsService").then(({ useAnalyticsService }) => {
        useAnalyticsService().trackContentLinkClicked(Store.project.id.value!, this.to);
      });
    }
  }

  private get to() {
    return this.props.to.replace("#", "");
  }

  render() {
    return (
      <span
        className="inline relative cursor-pointer px-1.5 py-0.5 bg-secondary hover:bg-gray-200 transition-all rounded-full"
        onClick={this.onClick}
      >
        <slot></slot>
      </span>
    );
  }
}
